import api from "../api";

export const fetchWisdomDashboardGeneralInfoData = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/dashboard/general-information`);
    return response.data.generalInfo || {};
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
};

export const fetchWisdomEmployeesAbsence = async () => {
  try {
    const response = await api.get(`/api/v1/wisdom/data/employees-absence`);
    return response.data.employees || {};
  } catch (error) {
    console.error('Error fetching Wisdom Detailed Data:', error);
    throw error;
  }
};